import React, { useEffect, useState } from 'react';
import { StyledContainer } from './index.styles';
import { FormErrors, RegistrationReoSchema } from './form';
import { PageState } from './types';
import Header from './components/Header';
import RegistrationFirstPage from './RegistrationFirstPage';
import RegistrationSecondPage from './RegistrationSecondPage';
import { useLanguage } from 'src/common/hooks';
import { RegisterText } from '../RegisterUBNP/components/CommonParagraph/index.styles';
import { Box } from '@mui/material';

export default function RegisterReo() {
  const { setLanguage, t } = useLanguage();

  const [form, setForm] = useState<RegistrationReoSchema>({
    organization_name: '',
    vat_identifier: '',
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    city: '',
    consent_marketing: false,
    consent_reo_analytics: false,
    password: '',
  });
  const [pageState, setPageState] = useState<PageState>(
    'registration-first-page'
  );
  const [errors, setErrors] = useState<FormErrors>({});

  const onNextPage = () => {
    setPageState('registration-second-page');
    window.scrollTo(0, 0);
  };

  const onPreviousPage = () => {
    setPageState('registration-first-page');
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    setLanguage('pl');
  }, []);

  return (
    <StyledContainer>
      <Header />
      <form style={{ marginLeft: '10px', marginRight: '10px' }}>
        {pageState === 'registration-first-page' && (
          <>
            <Box mx="10px">
              <p
                dangerouslySetInnerHTML={{
                  __html: t('registration_bnp:reo.introduction'),
                }}
               />
            </Box>
            <RegisterText>{t('registration_reo:registerText')}</RegisterText>
          </>
        )}
        {pageState === 'registration-first-page' && (
          <RegistrationFirstPage
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            onNext={onNextPage}
          />
        )}
        {pageState === 'registration-second-page' && (
          <RegistrationSecondPage
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            onPrevious={onPreviousPage}
          />
        )}
      </form>
    </StyledContainer>
  );
}
